import GlassCard from '@/components/GlassCard';
import useThemeColors from '@/hooks/useThemeColors';
import { User } from '@/types';
import { useTranslation } from 'react-i18next';

interface Props {
    user: User;
}
const Forums: React.FC<Props> = ({ user }) => {
    const colors = useThemeColors();
    const { t } = useTranslation();
    return (
        <div className="mx-auto max-w-4xl">
            <GlassCard className="p-8 shadow-lg">
                <div className="py-12 text-center">
                    <svg
                        className={`mx-auto mb-4 h-12 w-12 ${colors.iconColor}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                        />
                    </svg>
                    <h2 className="mb-2 text-xl font-semibold text-gray-900 dark:text-white">
                        {t('myAccount.forums')}
                    </h2>
                    <p className="text-gray-600 dark:text-neutral-400">
                        {t('myAccount.forumsComingSoon')}
                    </p>
                </div>
            </GlassCard>
        </div>
    );
};

export default Forums;
